import React, { useState, useEffect } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import { useHttp } from '../../../hooks/http.hook';
import { useMessageError, useMessageSuccess } from '../../../hooks/message.hook';
import FormWrapper from './FormWrapper/FormWrapper';
import Container from '../../../components/Container/Container';
import BurgerMenu from '../../../components/BurgerMenu/BurgerMenu';
import ActiveStatusBadge from '../../../components/ActiveStatusBadge';

const Addresses = () => {
    const { request } = useHttp();
    const messageError = useMessageError();
    const messageSuccess = useMessageSuccess();
    const [showModal, setShowModal] = useState(false);
    const [showDel, setShowDel] = useState(false);
    const [delId, setDelId] = useState();
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [addresses, setAddresses] = useState([]);

    const fetch = async () => {
        try {
            const data = await request('admin/addresses/getall', 'GET');
            setAddresses(data.data);
        } catch (error) {
            messageError(error);
        }
    };

    useEffect(() => {
        fetch();
    }, []);

    const handleDelete =  (id) => {
        setShowDel(true);
        setDelId(id)
    };
    const handleDeleteAccess = async () => {
        try {
            const data = await request(`admin/addresses/delete/${delId}`, 'DELETE');
            messageSuccess(data.message);
            setDelId("")
            fetch();
            setShowDel(false);
        } catch (error) {
            messageError(error);
        }
    };

    const handleCreate = () => {
        setShowModal(true);
        setSelectedAddress(null);
    };
    const handleEdit = (id) => {
        setSelectedAddress(id);
        setShowModal(true);
    };
    const handleCloseModal = (success = false) => {
        setShowModal(false);
        if(success) {fetch();}
    };
    const handleCloseDel = () => {
        setShowDel(false);
        setDelId("")
    }

    return (
        <>
            <Container>
                <BurgerMenu />
                <h2>Всі Адреси</h2>
                <p>Kількість: <span>{addresses.length}</span></p>
                <div className='d-flex justify-content-end'>
                    <Button variant="dark" className='mb-3' onClick={() => handleCreate()}>Створити</Button>{' '}
                </div>
                <div className='table__wrapper'>
                    <Table striped bordered hover className='table__main'>
                        <colgroup>
                            <col className="low" />
                            <col className="middle" />
                            <col className="middle" />
                            <col className="middle" />
                            <col className="middle" />
                        </colgroup>
                        <thead className='table__head'>
                            <tr>
                                <th>#</th>
                                <th>Назва</th>
                                <th>Адреса</th>
                                <th>Статус</th>
                                <th>Взаємодія</th>
                            </tr>
                        </thead>
                        <tbody>
                            {addresses.length > 0 && addresses.map((address, index) => (
                                <tr key={address._id}>
                                    <td>{index + 1}</td>
                                    <td>{address.name}</td>
                                    <td><p>{address.address}</p></td>
                                    <td><ActiveStatusBadge active={address.active} styled={false} /></td>
                                    <td>
                                        <Button variant="secondary" onClick={() => handleEdit(address._id)}>Редагування</Button>{' '}
                                        <Button variant="danger" onClick={() => handleDelete(address._id)}>Видалити</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                            {/* Modal for editing brand */}
                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedAddress ? "Редагування" : "Створення"} категорії</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedAddress && <FormWrapper create={false} edit={true} id={selectedAddress} onSubmit={handleCloseModal} close={handleCloseModal}/>}
                        {!selectedAddress && <FormWrapper create={true} edit={false} id={selectedAddress} onSubmit={handleCloseModal} close={handleCloseModal}/>}
                    </Modal.Body>
                </Modal>
                <Modal show={showDel} onHide={handleCloseDel}>
                    <Modal.Header closeButton>
                        <Modal.Title>Видалити</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Button variant="danger" onClick={() => handleDeleteAccess()}>Видалити</Button>
                    </Modal.Body>
                </Modal>
            </Container>
        </>
    );
};

export default Addresses;
